// ENTITY com.ic2.entity.UserBundle generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { User } from './User';
import { UserRight } from './UserRight';
import { UserConfig } from './UserConfig';
import { UserRelation } from './UserRelation';

export class UserBundle {

  static readonly __ic2_fqn: string = 'com.ic2.entity.UserBundle';

  user: User | null = null;
  config: UserConfig[] | null = [];
  rights: UserRight[] | null = [];
  relations: UserRelation[] | null = [];
  token: string | null = '';
  data: any | null = null;

  constructor(init?:Partial<UserBundle>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.entity.UserBundle'] = UserBundle;

fields['com.ic2.entity.UserBundle']  = {
    user: 'com.ic2.entity.User',
    config: 'java.util.List<com.ic2.entity.UserConfig>',
    rights: 'java.util.List<com.ic2.entity.UserRight>',
    relations: 'java.util.List<com.ic2.entity.UserRelation>',
    token: 'java.lang.String',
    data: 'java.lang.Object'
};
